import { For, Show } from "solid-js";
import { Badge } from "@/components/ui/badge";
import { subcategoryLabel } from "@/domains/freelance/taxonomy/store/taxonomy-store";
import { cn } from "@/libs/cn";

interface SubcategoryChipListProps {
  keys: readonly string[];
  label: string;
  inactive?: boolean;
  class?: string;
}

/**
 * Non-interactive list of subcategory chips. Presentational: it does not
 * filter `keys`, and renders nothing when empty. `label` is not shown: it
 * names the list for screen readers.
 */
export function SubcategoryChipList(props: SubcategoryChipListProps) {
  return (
    <Show when={props.keys.length > 0}>
      <ul
        // biome-ignore lint/a11y/noRedundantRoles: WebKit drops list semantics with list-style: none
        role="list"
        aria-label={props.label}
        class={cn("flex flex-wrap items-center gap-1.5", props.class)}
      >
        <For each={props.keys}>
          {(key) => (
            <li>
              <Badge
                variant={props.inactive ? "secondary" : "info-static"}
                size="sm"
                class="rounded-full"
              >
                {subcategoryLabel(key)}
              </Badge>
            </li>
          )}
        </For>
      </ul>
    </Show>
  );
}
